export const language = (t) => {
    return {
        zeroRecords: `${t('table.zeroRecords')}`,
        loadingRecords: `${t('table.loadingRecords')}`,
        infoEmpty: `${t('table.noRecordsAvailable')}`,
        processing: `<span>${t('table.loadingRecords')}</span>`,
        info: `_START_ - _END_ <span>${t('table.of')}</span> _TOTAL_ <span>${t('table.recordsUnit')}</span>`,
    }
}
